import React, {FunctionComponent} from 'react';
import './Stepper.scss';
import StepperLine from "./StepperLine";

interface StepperProps {
    currentStep: number;
    setCurrentStep: (step: number) => void;
}

/**
 * Stepper component
 * @param {StepperProps} props - The props that the Stepper component accepts.
 * @param {number} props.currentStep - The current step that should be displayed.
 * @param {Function} props.setCurrentStep - Function to change the current step.
 * @constructor
 */
const Stepper: FunctionComponent<StepperProps> = (props) => {
    return <div className={'stepper'}>
        <div className={'stepper-nav'}>
            {React.Children.map(props.children, (Child, index) => <>
                {index !== 0 && <StepperLine />}
                {React.isValidElement(Child) && React.cloneElement(Child, {completed: props.currentStep > index + 1, active: props.currentStep === index + 1})}
            </>)}
        </div>
        <div className={'stepper-view'}>
            {React.Children.map(props.children, (Child, index) => <>
                {props.currentStep === index + 1 && React.isValidElement(Child) && Child.props.children}
            </>)}
        </div>
    </div>;
}

export default Stepper;